export const DIRECTION = {
  FROM: 'from',
  TO: 'to'
} as const

export type Direction = (typeof DIRECTION)[keyof typeof DIRECTION]


export const urlParamQuantityToConvert = 'q' as const

export const CLOUDFLARE_DOMAIN_ENDING = '.pages.dev'
